var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.72 39.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .facebook-footer-1 {\n        fill: #3b5572;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook_Footer_1",
    "data-name": "Facebook Footer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "facebook-footer-1",
    d: "M19.86,0C8.89,0,0,8.91,0,19.91c0,9.94,7.26,18.17,16.76,19.67v-13.91h-5.04v-5.75h5.04v-4.39c0-4.99,2.97-7.75,7.5-7.75,2.17,0,4.45.39,4.45.39v4.9h-2.5c-2.47,0-3.24,1.53-3.24,3.11v3.73h5.51l-.88,5.75h-4.63v13.91c9.5-1.49,16.76-9.73,16.76-19.67C39.72,8.91,30.83,0,19.86,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFooter);
export default __webpack_public_path__ + "static/media/Facebook-Footer.89ed20e77575210286719bf945fcd2b8.svg";
export { ForwardRef as ReactComponent };